import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService } from 'tms-lib';
import { ShipperAccount } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShipperAccountService extends TmsWebBaseEditCreateService<ShipperAccount, ShipperAccount> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('ShipperAccount', $localize`Shipper Account`, httpService, notificationService);
  }

  getForSupplier(id: string): Observable<ShipperAccount[]> {
    return this.httpService.get<ShipperAccount[]>(`${this.apiUrl}/GetForSupplier?id=${id}`);
  }
}
